import { CircleX } from 'lucide-react';

export function ErroProcessoReact() {
  const params = new URLSearchParams(window.location.search);
  const parentOrigin = params.get('parentOrigin') || '*';
  const erro = sessionStorage.getItem('erroMensagem') || 'Ocorreu um erro inesperado.';

  const handleNotifyError = () => {
    window.parent.postMessage(
      {
        type: 'REACT_FLOW',
        status: 'ERROR',
        error: erro
      },
      parentOrigin
    );
  };

  return (
    <div className='content'>
      <div className='content-liveness'>
        <div className='header'>Validação</div>
        <div className='content-success'>
          <CircleX color='#F71A1A' strokeWidth={2} size={150}/>
          <span>Não foi possível concluir a verificação.</span>
          <span className='sub-success'>{erro}</span>
          <button onClick={handleNotifyError}>Reportar erro</button>
        </div>
      </div>
    </div>
  );
}
